export function handleSearchNavicon() {
    const searchIcon = document.querySelector('.site-header__search-navicon');
    const searchDiv = document.querySelector('.site-header__search');

    if(searchIcon && searchDiv){
        searchIcon.addEventListener('click', function() {
            if(searchDiv.classList.contains('site-header__search--active')){
                searchDiv.classList.remove('site-header__search--active');
            } else {
                searchDiv.classList.add('site-header__search--active');
            }
            
        });
    }
}